export default __webpack_public_path__ + "static/media/call-outcome-signal.43928d0f.svg";